module.exports = __webpack_public_path__ + "img/nocelebration.2816c4a9.png";